












































































import { getRestoreUserDocument, postBroadcastToBlockchain, postRestoreToGetUserTransactions, postRestoreUser } from '@/api'
import { handleError, handleErrorMessage } from '@/error/sentry'
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  name: 'EnableTransaction',
  components: {}
})
export default class EnableTransaction extends Vue {
  @Prop(String) restoreCode
  @Prop(Object) restoreUser

  t (key: string) {
    return this.$t(`EnableTransaction.${key}`)
  }

  seedPhrase = '';
  displayMessage = false;
  modalView = false
  error = false

  restoreDocumentBase64PDF = ''
  waves = require('@waves/waves-transactions')

  async mounted () {
    const restoreDocument = (await getRestoreUserDocument(this.restoreCode)).data
    this.restoreDocumentBase64PDF = restoreDocument[0].data
  }

  downloadPdf () {
    const linkSource = `data:application/pdf;base64,${this.restoreDocumentBase64PDF}`
    const downloadLink = document.createElement('a')
    const fileName = 'auth.pdf'
    downloadLink.href = linkSource
    downloadLink.download = fileName
    downloadLink.click()
  }

  continueView () {
    this.modalView = false
    this.$emit('nextClick')
  }

  async signTransaction () {
    try {
      if (this.seedPhrase === '') return

      const wallet: any = this.restoreUser.wallet
      const transactions = (await postRestoreToGetUserTransactions(wallet.address, wallet.publicKey, wallet.addressNew)).data

      if (transactions.length !== this.restoreUser.assets.length) { this.error = true; return }
      let signedTransaction: any = ''
      for (const transaction of transactions) {
        try {
          if (this.error) return
          signedTransaction = this.waves.transfer(transaction, this.seedPhrase)
          // Change order of proofs
          signedTransaction = { ...signedTransaction, proofs: [signedTransaction.proofs[1], signedTransaction.proofs[0]] }
          await postBroadcastToBlockchain(signedTransaction)
          this.modalView = true
        } catch (err) {
          handleError(err)
          handleErrorMessage(signedTransaction)
          this.seedPhrase = ''
          this.error = true
        }
      }

      setTimeout(async () => await postRestoreUser(this.restoreCode), 10000)
    } catch (err) {
      handleError(err)
      this.seedPhrase = ''
      this.error = true
    }
  }
}
